import { Box, Stack, xcss } from '@atlaskit/primitives';
import React from 'react';
import ErrorIcon from '../../assets/ErrorIcon.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const wrapperStyles = xcss({
  paddingTop: 'space.400',
  paddingBottom: 'space.600'
});
const loadingTextStyles = xcss({
  fontSize: '1rem',
  fontWeight: 600,
  textAlign: 'center'
});
export const ErrorState = () => /*#__PURE__*/_jsxs(Stack, {
  alignBlock: "center",
  alignInline: "center",
  space: "space.200",
  xcss: wrapperStyles,
  children: [/*#__PURE__*/_jsx("img", {
    src: ErrorIcon,
    alt: "",
    width: "120px"
  }), /*#__PURE__*/_jsx(Box, {
    xcss: loadingTextStyles,
    paddingInline: "space.400",
    children: "We're having trouble loading, refresh to try again."
  })]
});